import { Component, OnInit } from '@angular/core';
import {RoutesService} from "../../../core/services/routes.service";

@Component({
  selector: 'app-denture',
  templateUrl: './denture.component.html',
  styleUrls: ['./denture.component.scss']
})
export class DentureComponent implements OnInit {

  constructor(
      public routesService: RoutesService
  ) { }

  ngOnInit(): void {
  }

}
